import {lightGray} from '@modifi/colors'
import {Link} from '@modifi/router'
import {Row, media} from '@modifi/ui'
import styled from 'styled-components'

type CardType = {
  small?: boolean
}

export const Card = styled(Row)<CardType>`
  border: 1px solid ${lightGray};
  border-radius: 4px;
  margin: 1px;
  padding: 16px 8px;
  ${media.lg<CardType>`
    min-height: ${({small}): string => (small ? '100px' : '186px')};
  `}
`

export const Wrapper = styled.div`
  padding-bottom: 32px;
  min-height: 50vh;
`

export const UnstyledLink = styled(Link)`
  text-decoration: none;
`

export const LimitCard = styled.div<{highlightColor: string; bgColor: string}>`
  padding: 8px 16px;
  border-radius: 2px;
  ${({highlightColor, bgColor}): string => `
    background-color: ${bgColor};

    h6{
      color: ${highlightColor};
    }
  `}

  small {
    display: flex;
    align-items: center;
  }

  svg {
    margin-left: 8px;
  }
`
